export default __webpack_public_path__ + "static/media/bg-pattern-quotation.6b460e30.svg";